module["exports"] = [
  "#{first_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name}",
  "#{first_name} #{last_name} #{last_name} #{last_name}"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/vi/name/name.js
 ** module id = 1172
 ** module chunks = 0
 **/